<script setup>
import { computed } from 'vue'
import { resolveApiAssetUrl } from '@/utils/algorithmPublicAssets'

const props = defineProps({
  list: {
    type: [Array, Object],
    default: () => [],
  },
})

const applicationImage = (item) =>
  item?.src ||
  item?.url ||
  item?.image ||
  item?.image_url ||
  item?.imageUrl ||
  item?.cover ||
  item?.cover_url ||
  item?.coverUrl ||
  item?.path ||
  ''

const applicationList = computed(() =>
  Array.isArray(props.list)
    ? props.list
    : props.list && typeof props.list === 'object'
      ? Object.values(props.list)
      : [],
)
</script>

<template>
  <section class="use-container">
    <div class="container py-md-3 py-lg-4 py-xl-5 mb-xxl-4">
      <div class="title">应用场景</div>
      <div
        :class="[
          'row',
          'g-lg-4',
          'row-cols-1',
          'row-cols-md-2',
          'row-cols-lg-3',
        ]"
      >
        <div
          class="col"
          v-for="(item, index) in applicationList"
          :key="applicationImage(item) || item.name || index"
        >
          <div class="bg-white h-100 px-4 py-5">
            <img
              :src="resolveApiAssetUrl(applicationImage(item))"
              :alt="item.name || '应用场景'"
              width="100%"
              height="auto"
              loading="lazy"
            />
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.pt-4 {
  padding-top: 1.5rem !important;
}

.use-container {
  padding-top: 3rem;
  padding-bottom: 3rem;
  box-sizing: border-box;
  min-width: 1270px;
  width: 100%;
  .container {
    width: 100%;
    padding-right: calc(3rem * 0.5);
    padding-left: calc(3rem * 0.5);
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
    .title {
      font-size: 30px;
      text-align: center;
      margin-bottom: 8px;
      font-weight: 500;
    }
    .row {
      display: flex;
      flex-wrap: wrap;
      padding-top: 70px;
      margin-top: calc(-1 * 1.5rem);
      margin-right: calc(-0.5 * 1.5rem);
      margin-left: calc(-0.5 * 1.5rem);
      box-sizing: border-box;
      justify-content: center;
      .bg-white {
        background-color: #f3f5f5;
        .avatar {
          margin-bottom: 16px;
        }

        .name {
          font-size: 22px;
          padding: 24px;
          color: #1a1a1a;
        }
      }
      & > * {
        flex-shrink: 0;
        width: 100%;
        max-width: 100%;
        padding-right: 8px;
        padding-left: 8px;
        margin-top: 1.5rem;
      }
    }
    .row-cols-1 > * {
      flex: 0 0 auto;
      width: 100%;
    }
  }
}

.col {
  flex: 1 0 0%;
  box-sizing: border-box;

  .text-555 {
    margin-bottom: 0.5rem;
  }
  .text-666 {
    margin-bottom: 1rem;
  }
}
</style>
<style scoped lang="scss">
.py-lg-4 {
  padding-top: 12px;
  padding-bottom: 12px;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px !important;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px !important;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px !important;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px !important;
  }
}
@media (min-width: 1400px) {
  .container {
    max-width: 1320px !important;
  }
}
@media screen and (min-width: 1500px) {
  .container {
    max-width: 1448px !important;
  }
}

@media (min-width: 768px) {
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
}
@media (min-width: 992px) {
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
}

@media (min-width: 768px) {
  .row-cols-md-2 > * {
    flex: 0 0 auto !important;
    width: 65% !important;
  }
}
@media (min-width: 992px) {
  .row-cols-lg-3 > * {
    flex: 0 0 auto !important;
    width: 45% !important;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-0 > * {
    flex: 0 0 auto !important;
    width: 50% !important;
  }
}
</style>
